<template lang="pug" src="./modal-appointment.pug"></template>

<script>
import api from 'api'
import axios from 'axios'

export default {
  props: ['props'],
  data () {
    return {
      error: false,
      submitted: false,
      dropdown: false,
      first_name: '',
      last_name: '',
      first: '',
      office: 'Choose a Location',
      phone: '',
      email: '',
      hear: '',
      message: '',
      postUrl: api + '/rg-mail/v1/contact',
      formSuccess: false
    }
  },
  methods: {
    location () {
      this.dropdown ? this.dropdown = false : this.dropdown = true
    },
    setLocation (l) {
      this.office = l
      this.dropdown ? this.dropdown = false : this.dropdown = true
    },
    formSubmitted () {
      if (this.office === 'Choose a Location') {
        this.error = true
      }
      if (!this.error) {
        this.submitted = true
        axios.post(this.postUrl, {
          first_name: this.first_name,
          last_name: this.last_name,
          first: this.first,
          office: this.office,
          phone: this.phone,
          email: this.email,
          hear: this.hear,
          message: this.message
        })
          .then(res => { this.success() })
          .catch(e => { console.log(e) })
      }
    },
    success () {
      this.formSuccess = true
      setTimeout(e => {
        this.$store.dispatch('VIEW_SHOWMODAL', false)
        this.submitted = false
        this.first_name = ''
        this.last_name = ''
        this.first = ''
        this.office = 'Choose a Location'
        this.phone = ''
        this.email = ''
        this.hear = ''
        this.message = ''
      }, 2000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/modal-appointment/modal-appointment.vue